import { useEffect, useState } from 'react';
import { ConfirmDialog } from '@components/primitives/ConfirmDialog';
import { TextField } from '@mui/material';

const MAX_REASON_LENGTH = 1000;

const MESSAGES = {
  admin:
    'You can still make changes. Add a short reason so reviewers can see why a verified intake changed. It is saved with every change in this save.',
  provider:
    'You can still make changes. Editing will send your profile back to our team for review, so add a short reason for the change.',
} as const;

interface VerifiedEditReasonDialogProps {
  open: boolean;
  audience: keyof typeof MESSAGES;
  onSubmit: (reason: string) => void;
  onCancel: () => void;
}

/** Required-reason prompt shown before a verified intake is changed (GDN-4034). */
export function VerifiedEditReasonDialog({
  open,
  audience,
  onSubmit,
  onCancel,
}: VerifiedEditReasonDialogProps) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <ConfirmDialog
      open={open}
      variant="info"
      title="This intake is verified"
      message={MESSAGES[audience]}
      confirmText="Save with reason"
      disableConfirm={!reason.trim()}
      onClose={onCancel}
      onConfirm={() => onSubmit(reason)}
    >
      <TextField
        autoFocus
        fullWidth
        multiline
        minRows={2}
        required
        label="Reason for the change"
        value={reason}
        onChange={event => setReason(event.target.value)}
        slotProps={{ htmlInput: { maxLength: MAX_REASON_LENGTH } }}
        sx={{ mt: 2 }}
      />
    </ConfirmDialog>
  );
}
